export default [
  {
    path: "bot-ai-integration",
    component: () =>
      import(
        /* webpackChunkName: "bot-ia-integration-page" */ "@/app/flows/botAIIntegration/pages/BotAIIntegrationPage.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "bot-ia-integration-list" */ "@/app/flows/botAIIntegration/templates/BotAIIntegrationListTemplate.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ":id",
        component: () =>
          import(
            /* webpackChunkName: "bot-ia-integration-details" */ "@/app/flows/botAIIntegration/templates/BotAIIntegrationDetailTemplate.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
